import { useLocation, useNavigate } from "react-router-dom";
import Custom from "../../Components/Buttons/Custom";
import SVG from "../../Components/SVG";

export default function BuyStatus() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const status = new URLSearchParams(search).get("status");
  const variant = status === "success" ? "success" : "fail";

  const variants = {
    success: {
      svgName: "check",
      header: "پرداخت موفق!",
      description: "خرید چالش با موفقیت انجام شد.",
      buttonText: "انتقال به صفحه حساب‌ها و چالش‌ها",
      onclick: () => navigate("/challenge"),
    },
    fail: {
      svgName: "close",
      header: "پرداخت ناموفق!",
      description: "خرید چالش موفق نبود، لطفا مجددا تلاش کنید.",
      buttonText: "انتقال به صفحه میز کار",
      onclick: () => navigate("/dashboard"),
    },
  };

  const data = variants[variant];

  return (
    <div className="w-full h-full flex justify-center items-center">
      <section className="max-w-sm mx-auto shadow-lg bg-zi-bg2-light dark:bg-zi-bg2-dark p-5 rounded-2xl border border-zi-border-dark">
        <div className="flex flex-col items-center p-5">
          <div>
            <SVG
              name={data.svgName}
              classname="size-24 stroke-2 stroke-zi-text-light dark:stroke-zi-text-dark"
            />
          </div>

          <h2 className="mt-4 text-xl font-medium text-center text-zi-text-light dark:text-zi-text-dark">
            {data.header}
          </h2>

          <p className="mt-2 text-center text-zi-text-light/50 dark:text-zi-text-dark/50">
            {data.description}
          </p>
        </div>
        <Custom
          onClick={data.onclick}
          text={data.buttonText}
          className="px-5 min-w-40 whitespace-nowrap bg-zi-gradient-button-blue text-zi-text-dark hocus:ring-offset-1 hocus:ring-1 hocus:ring-zi-blue-light"
          textShadow={true}
        />
      </section>
    </div>
  );
}
